import { httpsCallable } from "firebase/functions";
import getFunctions from "../helpers/getFunctions";
import { ErrorResponse } from "./types";

type ActiveCodeParams = {
    code: string;
};

type ActiveCodeSuccessData = {
    message: string;
    tokensAdded: number;
};

const activeCode = (params: ActiveCodeParams) => {
    const functions = getFunctions();
    const callable = httpsCallable<
        ActiveCodeParams,
        ActiveCodeSuccessData | ErrorResponse
    >(functions, "useCode");
    return callable(params);
};

export default activeCode;
